"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductItemByHandle = void 0;
const react_1 = require("react");
const useProductByHandle_1 = require("./useProductByHandle");
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    options: {},
};
// DEPRECATED - use useProductByHandle instead
const useProductItemByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { product: productItem, fetchProductByHandle, ...productByHandleStatus } = (0, useProductByHandle_1.useProductByHandle)(props);
    (0, react_1.useEffect)(() => {
        if (process.env.NODE_ENV === 'development') {
            console.warn('useProductItemByHandle is deprecated. Please use useProductByHandle instead.');
        }
    }, []);
    return {
        productItem,
        fetchProductItemByHandle: fetchProductByHandle,
        ...productByHandleStatus,
    };
};
exports.useProductItemByHandle = useProductItemByHandle;
//# sourceMappingURL=useProductItemByHandle.js.map